import React from "react";
import { Link } from "react-router-dom";

const UnauthorizedPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-rose-600">
          You are not authorized to visit this page
        </h1>
        <p className="mt-4">
          Please contact your administrator if you believe this is an error.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block px-6 py-2 text-sm font-medium leading-6 text-center text-indigo-text-on-accent uppercase transition bg-sky-500 rounded shadow ripple hover:shadow-lg hover:bg-sky-600 focus:outline-none"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
